import { create } from 'zustand';
import {
  executeGQL,
  User,
  UsersQuery,
  UserSummaryFragmentDoc,
} from '../GraphQLHelpers';
import { useFragment } from '../generated/gql';

interface UserStore {
  userByID: Record<string, User>;
  fetchUsers: (userIDs: string[], force?: boolean) => Promise<void>;
}

export const useUserStore = create<UserStore>()((set, get) => ({
  userByID: {},

  fetchUsers: async (userIDs, force = false) => {
    let userIDsToFetch = userIDs;
    if (!force) {
      userIDsToFetch = userIDsToFetch.filter(
        (userID) => !get().userByID[userID],
      );
    }
    if (userIDsToFetch.length === 0) return;

    const result = await executeGQL(UsersQuery, { ids: userIDsToFetch });
    if (!result.data) return;

    const users = result.data.users?.map((user) => {
      return useFragment(UserSummaryFragmentDoc, user);
    });
    if (!users) return;

    set((state) => {
      const newUserByID = { ...state.userByID };
      users.forEach((user) => {
        newUserByID[user.id] = user;
      });
      return { userByID: newUserByID };
    });
  },
}));
